import { Link } from 'react-router-dom';
import { useLogo } from '@/context/LogoContext';

export interface BrandMarkProps {
  /** Mark only (side rail, phone). */
  compact?: boolean;
}

/** Practice logo: the configured icon (or the name's initial) plus the name. */
export default function BrandMark({ compact = false }: BrandMarkProps) {
  const { logoSettings } = useLogo() as { logoSettings: { heading?: string; icon?: string; showIcon?: boolean; useCustomSvg?: boolean; style?: { headingColor?: string } } | null };
  const name = logoSettings?.heading?.trim() || 'Chartly';
  const customIcon = logoSettings?.showIcon && !logoSettings.useCustomSvg ? logoSettings.icon?.trim() : '';
  return (
    <Link to="/" aria-label={`${name} home`} className="flex flex-none items-center gap-2 rounded-md text-slate-900 dark:text-slate-50">
      {customIcon ? (
        <span aria-hidden="true" className="flex h-7 w-7 items-center justify-center text-xl leading-none">{customIcon}</span>
      ) : (
        <span aria-hidden="true" className="flex h-7 w-7 items-center justify-center rounded-lg bg-primary-600 text-sm font-bold text-white">{name[0]?.toUpperCase()}</span>
      )}
      {!compact && (
        <span className="text-[15px] font-bold tracking-tight" style={{ color: logoSettings?.style?.headingColor || undefined }}>{name}</span>
      )}
    </Link>
  );
}
